import jszip from 'jszip';
import filesaver from 'file-saver';

export default class GpxZipper {

    static init() {
        const els = document.querySelectorAll('.asd-gpx-zipper');
        if (!els) {
            console.log('no els',els);
            return;
        }
        els.forEach( el => {
            const act_id = el.getAttribute('data-act',0);
            if (parseInt(act_id) > 0) {
                try {
                    new GpxZipper(el, parseInt(act_id));
                }
                catch (e) { console.log(e) }
            } else {
                console.log('Error initiating GpxZipper');
            }

        })
    }

    /**
     *
     * @param el Node
     * @param act_id number
     */
    constructor(el, act_id) {
        this.el = el;
        this.act_id = act_id;
        this.personsMap = [];

        let button = this.el.querySelector('.btn');
        const p = this.el.querySelector('input').value;
        let persons;
        try {
            persons = JSON.parse(p);
        } catch (e) {
            console.log('Cannot parse persons', p);
        }

        if (!Array.isArray(persons) || persons.length <= 0) {
            throw new Error('Person is not correct', persons);
        }
        this.persons = persons;
        this.totalCount = this.persons.length;

        if (!button) {
            throw new Error('Cannot find button', el);
        }
        this.startButton = button;

        this.setupElements();

        this.halt = false;

        this.startButton.addEventListener('click', this.zipTracks.bind(this) );
    }

    setupElements() {
        this.row = document.createElement('div');
        this.row.classList.add('row');

        // Counters
        this.counter = document.createElement('div');
        this.counter.classList.add('progress');

        this.counterPercent = document.createElement('div');
        this.counterPercent.classList.add('determinate');
        this.counter.appendChild(this.counterPercent);

        this.counterValue = document.createElement('p');

        // Stop button
        this.stopButton = document.createElement('a');
        this.stopButton.classList.add('btn');
        this.stopButton.classList.add('red');
        this.stopButton.classList.add('darken-4');
        this.stopButton.innerText = 'Ferma';
        this.stopButton.addEventListener('click', this.stop.bind(this) );

        this.row.appendChild(this.counter);
        this.row.appendChild(this.counterValue);
    }

    initDownload() {
        this.counterPercent.style.width = '0%';
        this.counterValue.innerText = 0;

        this.el.appendChild(this.stopButton);
        this.el.appendChild(this.row);
    }

    stop() {
        this.halt = true;
    }

    zipTracks() {
        this.initDownload();
        this.downloadTracks()
            .then( responses => {
                let zip = new jszip();
                let counter = 0;
                for (let gpx of responses) {
                    // console.log(gpx.config.url, this.personsMap, this.persons);

                    let personKey = this.personsMap.indexOf(this.personsMap.find( x => {
                        return x === gpx.config.url
                    }));
                    const person = this.persons[personKey];
                    zip.file("gpx_att"+this.act_id+"_p"+person.person_id+"_"+person.surname+' '+person.name+".gpx", gpx.data);
                    counter++;
                }
                zip.generateAsync({type: "blob"})
                    .then( this.zipGenerated.bind(this) );
            })
            .catch( console.log );
    }

    zipGenerated( content ) {

        filesaver.saveAs(content, "tracks_"+this.act_id+".zip");
        this.stopDownload();

    }

    stopDownload() {
        this.el.removeChild(this.row);
        if ( this.el.isEqualNode(this.stopButton.parentElement) )
            this.el.removeChild(this.stopButton);
        this.halt = false;
    }

    /**
     * Execute the download of the tracks
     * @returns {Promise<[]>} Axios array of responses
     */
    async downloadTracks() {
        let url = '/index.php?option=com_asdgest&view=activitylog&format=gpx&act_id='+this.act_id+'&person_id=';
        let arr = [];

        for (let i = 0; i< this.persons.length; i++) {
            let person = this.persons[i];

            if (this.halt) {
                this.stopDownload();
                return Promise.reject('has been stopped by the user');
            }

            try {
                let gpx = await window.axios.get(url+person.person_id);
                arr.push( gpx );
            }
            catch (err) {

            }

            this.counterValue.innerText = 'Scaricate '+ (i+1) + '/' + this.totalCount;
            this.counterPercent.style.width = (i * 100) / this.totalCount + '%';

            this.personsMap[i] = url+person.person_id;
        }

        if ( this.el.isEqualNode(this.stopButton.parentElement) )
            this.el.removeChild(this.stopButton);
        this.counterValue.innerText = 'Elaborazione in corso';
        this.counterPercent.style.width = '';
        this.counterPercent.classList.add('indeterminate');
        this.counterPercent.classList.remove('determinate');

        return arr;
    }
}
